<template>
  <v-card
    class="secondary--text utilities-dialog"
    style="height: 90vh"
    @close:dialog="close"
  >
    <vue-scroll :ops="ops">
      <v-btn
        color="info"
        icon
        class="float-right pa-10 btn--plain"
        @click="close"
      >
        <v-icon>mdi-close</v-icon>
      </v-btn>
      <div
        class="utilities-dialog__form px-8 pt-10 pb-4 mx-auto text-left"
      >
        <div class="custom-title py-8">
          Download & Print
        </div>

        <div
          v-if="currentCase.filingPlan === 'E-FILE'"
          class="pb-10"
        >
          When submitting your documents through the Court's e-filing system—Judiciary Electronic Document Submission (JEDS)—you'll
          be asked to upload the <span class="font-weight-bold">Verified Complaint</span> and <span class="font-weight-bold">Tenant Summons</span> separately.
          You may upload the Cover Letter as a supporting document. Do NOT upload the instructions. Those are exclusively for you.
          Download the files you need.
        </div>
        <div
          v-else
          class="pb-10"
        >
          Print all documents. Provide the court with the Cover Letter along with the <span class="font-weight-bold">Verified Complaint</span> and <span class="font-weight-bold">Tenant Summons</span>.
          Do NOT submit the instructions. Those are exclusively for you.
        </div>

        <v-card
          v-for="(fileType, index) in fileTypes"
          :key="index"
          elevation="0"
          :class="fileType.name === 'Print all' ? 'letter-item-border-greyed-out' : 'letter-item-border'"
          class="letter-item"
          style="background: #FAFBFC;"
          @click="printPleading(fileType)"
        >
          <v-row>
            <v-col
              cols="10"
            >
              <i
                :class="[fileType.icon_class, fileType.icon]"
                class="icofont-2x mr-3"
              />
              <span
                :class="fileType.name === 'Print all' ? '' : 'accent2--text'"
                style="position: relative; bottom: 5px;"
              >
                {{ fileType.name }}
              </span>
            </v-col>

            <v-col>
              <i
                :class="fileType.icon_class"
                class="icofont-print icofont-2x mr-5"
              />
            </v-col>
          </v-row>
        </v-card>
      </div>

      <v-card-actions
        style="background-color: #fafbfc; border-radius: 0px 0px 10px 10px"
        class="justify-end py-4 pr-12 mt-12"
      >
        <v-btn
          rounded
          color="accent_light"
          class="mb-2 mt-4 btn--plain capital--btn"
          text
          @click="close"
        >
          Cancel
        </v-btn>
        <v-btn
          rounded
          color="accent_light"
          class="px-8 mb-2 mt-4 white--text capital--btn"
          depressed
          @click="close"
        >
          Done
        </v-btn>
      </v-card-actions>
    </vue-scroll>
  </v-card>
</template>

<script>
import { mapGetters } from 'vuex';
import writtenNumber from 'written-number';
import { downloadPDF } from "../../utils";
import PDFTemplateData from '@/mixins/pdf-template-data';
// import calculateFees from '@/mixins/calculate-fees';

export default {
  name: "PrintPleadingsDialog",
  mixins: [PDFTemplateData],
  // props: {
  //   fees: {
  //     type: Object,
  //     default: () => ({}),
  //   }
  // },
  data() {
    return {
      fileTypes: [
        { icon: 'icofont-file-word', icon_class: 'accent2--text', name: 'Cover Letter', templateName: 'cover_letter' },
        { icon: 'icofont-file-pdf', icon_class: 'accent2--text', name: 'Verified Complaint', templateName: 'verified_complaint_n_landlord_verification' },
        { icon: 'icofont-file-pdf', icon_class: 'accent2--text', name: 'Tenant Summons', templateName: 'tenant_summons' },
        { icon: 'icofont-file-pdf', icon_class: 'accent2--text', name: 'Instructions', templateName: 'instructions' },
        { icon: 'icofont-file-pdf', icon_class: 'grey--text', name: 'Print all', templateName: 'print_all' },
      ],
      ops: {
        vuescroll: {},
        scrollPanel: {},
        rail: {
          //background: '#EAEBEB',
          opacity: 0,
          size: '5px',
          specifyBorderRadius: false,
          gutterOfEnds: null,
          gutterOfSide: '0px',
        },
        bar: {
          onlyShowBarOnScroll: false,
          keepShow: true,
          background: '#4DCCC4',
          opacity: 1,
          size: '6px',
        }
      }
    };
  },
  computed: {
    ...mapGetters({
      currentCase: "eviction/currentCase",
      case: "eviction/currentCase",
      currentProperty: "property/currentProperty",
      mileage: "eviction/mileage",
      courtInfo: "eviction/courtInfo",
      orderDetails: "eviction/orderDetails",
      client: "client",
    }),
    totalComputed() {
      return this.case.feesTotal;
    },
  },
  methods: {
    close() {
      this.$emit("close:dialog");
    },
    findTemplateTypeOrderDetail() {
      // 1: full
      // 2: without section 8, but with e-file
      // 3: with section 8, but without e-file
      // 4: without section 8 and e-file
      if (!this.case.section8 && this.case.filingPlan === 'E-FILE') {
        return 2;
      }

      if (this.case.section8 && this.case.filingPlan !== 'E-FILE') {
        return 3;
      }

      if (!this.case.section8 && this.case.filingPlan !== 'E-FILE') {
        return 4;
      }

      return 1;
    },
    async printPleading(fileType) {
      const tenantsLength = this.currentCase.tenants.length * 2;

      const courtAddressState = this.mileage.courtAddress;

      const courtAddress = {
        countyCourt: courtAddressState.county,
        streetAddressCourt: courtAddressState.street,
        cityCourt: courtAddressState.city,
        stateCourt: courtAddressState.state,
        zipcodeCourt: courtAddressState.zipcode,
        phoneCourt: courtAddressState.phone
      }

      const data = {
        fileType: fileType.name,
        templateName: fileType.templateName,
        templateFileTypeSubfolder: this.findTemplateTypeOrderDetail(),
        data: {
          orderNo: this.orderDetails.orderNumber,
          filingType: this.currentCase.filingPlan,
          tenantFullNames: this.currentCase.tenants.map(tenant => tenant.name.trim().toUpperCase()).join(", "),
          exportDate: this.$dayjs().format("MMMM D, YYYY"),
          ownerName: this.currentProperty.deedNames.toUpperCase(),
          fileCopyAmount: `${writtenNumber(tenantsLength)} (${tenantsLength})`,
          section8: this.currentCase.section8,
          housingAuthorityWebsiteSection8: this.currentCase.publicHousingOfficeSection8 ? this.currentCase.publicHousingOfficeSection8.housingAuthorityWebsite : null,
          housingAuthorityAddressSection8: this.currentCase.publicHousingOfficeSection8 ? this.currentCase.publicHousingOfficeSection8.address : null,
          ...courtAddress,
          ...this.currentProperty.contactInfo,
          ...await this.getTemplateData()
        }
      };

      const response = await this.$http.post(`${process.env.VUE_APP_URL}/api/order/create-case-pleading-pdf`, data);

      downloadPDF(response.data.fileName, response.data.fileData);
    }
  }
};
</script>

<style lang="scss">
.letter-item {
  padding: 5px 40px 5px 40px;
  margin: 20px 0 20px 0;
  border-radius: 9px !important;
  cursor: pointer;
}

.letter-item-border {
  border: 3px solid #6a7fdb !important;
}

.letter-item-border-greyed-out {
  padding: 5px 40px 5px 40px;
  margin: 20px 0 20px 0;
  border: 3px solid #9e9e9e !important;
  border-radius: 9px !important;
  cursor: pointer;
}
</style>
